import { render, staticRenderFns } from "./WorkDocsSchemeTypeTable.vue?vue&type=template&id=6a6e07cc&"
import script from "./WorkDocsSchemeTypeTable.vue?vue&type=script&lang=js&"
export * from "./WorkDocsSchemeTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports